/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const ArrowSide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="ArrowSide">
    <path
      d="M3.875 5 .162 8.712l1.06 1.061L5.997 5 1.223.227l-1.06 1.06L3.874 5Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowSide;
